
import Auth from "./Auth"
import React from "react"

import 'bootstrap/dist/css/bootstrap.min.css'
import Error404 from "./Error404.js"
import {
    Switch,
    Route
} from "react-router-dom"
import Helmet from "react-helmet"
import FaqPage from './FaqPage'
import Notifications from './Notifications'
import Glossary from './Glossary'
import LogoutPage from './LogoutPage'
import HomePageApplication from './HomePageApplication'
import LoansV2 from "./ApplicationV2/LoansV2"
import CreditReportPayment from "./ApplicationV2/CreditReportPayment"
import SetUpPassword from "./newContent/page/setUpPassword"
import ChangePassword from "./newContent/page/changePassword"
import ApplicationInterviewV2 from "./ApplicationV2/ApplicationInterviewV2"

const AuthenticatedApplication = () => {


    return (
        <div className="mx-0 px-0 h-100">
            {sessionStorage.getItem("newcustomer") !== "true" && <Auth />}
            <Switch>



                <Route exact path="/application/changepassword">
                    <Helmet>
                        <title>My password </title>
                    </Helmet>

                    <ChangePassword />
                </Route>

                <Route exact path="/application/password">
                    <Helmet>
                        <title>My password </title>
                    </Helmet>

                    <SetUpPassword />
                </Route>

                <Route exact path="/application/myloans">
                    <Helmet>
                        <title>My Loans </title>
                    </Helmet>

                    <LoansV2 />
                </Route>

                <Route exact path="/application/credit-report-payment/:requestId">
                    <Helmet>
                        <title>Pay for credit report</title>
                    </Helmet>
                    <CreditReportPayment />
                </Route>

                <Route path="/application/v2/interview/:section?/:partyId?">
                    <Helmet>
                        {/* Borrower-facing tab title -- "V2" is our internal
                            name for the route, not something they should see. */}
                        <title>Mortgage Application Interview</title>
                    </Helmet>

                    <ApplicationInterviewV2 />
                </Route>

                <Route path="/application/">
                    <HomePageApplication />
                </Route>

                <Route exact path="/resources/faq">
                    <FaqPage />
                </Route>
                <Route exact path="/resources/glossary">
                    <Glossary />
                </Route>
                <Route exact path="/services/logout">
                    <LogoutPage />
                </Route>
                <Route >
                    <Error404 />
                </Route>
            </Switch>
            <Notifications />
        </div>
    )
}

export default AuthenticatedApplication
